import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { SETTINGS_ACTION_TYPE } from '../actions';

const initialState = {};

const settingsReducer = (state = initialState, { type, payload }) =>
  produce(state, draft => {
    switch (type) {
      case SETTINGS_ACTION_TYPE.GET_SETTINGS:
        return payload || initialState;

      case SETTINGS_ACTION_TYPE.EDIT_SETTING:
        draft[payload.name] = payload;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default settingsReducer;
